import React from 'react';
import * as PropTypes from 'prop-types';
import ProB01 from '../ProB01';
import Spa08 from '../Spa08';
import {
  TypographyWrapper,
  Caption2Normal,
  Caption2Strong,
  TypoText,
  LabelSmall,
  OptionWrapper,
  ParticipantValue,
  ToolTip,
} from './elements';
function COLab01(props) {
  let pColor = '';
  let iconName = '';
  let typoText = '';
  let opt = '';
  const percentValue = props.percentValue > 0 ? props.percentValue : 0;

  if (props.type === 'points') {
    pColor = '#8BC34A';
    iconName = 'icon-brightness_high';
    typoText = props.points_text;
  } else if (props.type === 'co2') {
    pColor = '#00AB97';
    iconName = 'icon-leaf';
    typoText = `KgCO2e`;
  } else if (props.type === 'activities') {
    pColor = '#0099A9';
    iconName = 'icon-check_circle';
    typoText = props.activities_text;
  } else if (props.type === 'participants') {
    pColor = '#8BC34A';
    iconName = 'icon-people';
    typoText = (
      <OptionWrapper>
        <Caption2Strong color="#263238">
          {props.participantCount}
        </Caption2Strong>
        <Caption2Normal color="#90a4ae">
          {' / '}
          {props.expectedParticipants}
        </Caption2Normal>
      </OptionWrapper>
    );
  }
  if (props.goal) {
    opt = (
      <OptionWrapper>
        <Caption2Normal color="#263238">
          {percentValue}
          {'%'}
        </Caption2Normal>
      </OptionWrapper>
    );
  }
  if (props.type === 'participants') {
    opt = (
      <OptionWrapper>
        <ParticipantValue color="#263238">
          {percentValue}
          {'% '}
        </ParticipantValue>
        <Caption2Normal color="#90a4ae">
          {props.participation_text}
        </Caption2Normal>
      </OptionWrapper>
    );
  }
  if (props.type === 'position') {
    opt = (
      <OptionWrapper>
        <LabelSmall
          position={props.position}
          content={props.position > 0 ? props.position : '-'}
          icon={props.position === 1 ? 'icon-crown' : 'icon-hashtag'}
        />
      </OptionWrapper>
    );
  }

  return (
    <div className={props.className}>
      <ToolTip text={props.tooltip_text}>
        <ProB01 color={pColor} percent={props.progPercent} />
      </ToolTip>
      <Spa08 />
      <TypographyWrapper>
        <LabelSmall
          content={props.points > 0 ? props.points : ''}
          icon={iconName}
        />
        <TypoText>{typoText}</TypoText>
        {opt}
      </TypographyWrapper>
    </div>
  );
}

COLab01.propTypes = {
  className: PropTypes.string,
  activities_text: PropTypes.string,
  participation_text: PropTypes.string,
  tooltip_text: PropTypes.string,
  points_text: PropTypes.string,
  expectedParticipants: PropTypes.number,
  goal: PropTypes.bool,
  participantCount: PropTypes.number,
  percentValue: PropTypes.number,
  points: PropTypes.number,
  position: PropTypes.number,
  progPercent: PropTypes.number,
  type: PropTypes.oneOf(['points', 'co2', 'activities', 'participants']),
};
export default COLab01;
